import { Link } from "react-router";

import { html } from "@utils/tailwind";

export const TableLink = html(
  Link
)`font-medium underline tracking-wide text-base underline-offset-2 hover:text-primary-600`;
